import { Avatar } from "../../components";
import type { PublicTableModel } from "../public-presentation";
import { publicSeatName } from "../public-presentation";
/** Public seat chips. Inputs are the positive public model only: alive/out,
 * connection, an established public actor and public dice counts. */
export function TableRoster({
  model,
  viewerId,
  showProgress = true,
}: {
  model: PublicTableModel;
  viewerId?: string | null;
  showProgress?: boolean;
}) {
  return (
    <div className="table-roster-wrap" data-tour="roster">
      <ul
        className={`table-roster${model.seats.length > 8 ? " is-crowded" : ""}`}
        aria-label="Players at the table"
      >
        {model.seats.map((s) => {
          const actor = s.id === model.actorId;
          const status = [
            !s.alive ? "Out" : null,
            s.connected === false ? "Offline" : null,
          ].filter(Boolean);
          return (
            <li
              key={s.id}
              className={`${actor ? "is-actor " : ""}${!s.alive ? "is-out " : ""}${s.connected === false ? "is-offline" : ""}`}
            >
              <span className="seat-avatar">
                <Avatar name={s.name} index={s.seat - 1} small />
                {s.connected === false ? (
                  <i className="seat-offline-dot" aria-hidden="true" />
                ) : null}
              </span>
              <span className="seat-identity">
                <strong>
                  {publicSeatName(model.seats, s.id)}
                  {s.id === viewerId ? (
                    <span className="seat-you"> · you</span>
                  ) : null}
                </strong>
                {status.length ? <small>{status.join(" · ")}</small> : null}
              </span>
              {s.alive && s.diceCount !== null ? (
                <span className="seat-dice">
                  <span className="dice-pips" aria-hidden="true">
                    {Array.from({ length: Math.min(s.diceCount, 6) }, (_, i) => (
                      <i key={i} />
                    ))}
                  </span>
                  <span className="sr-only">
                    {`${s.diceCount} ${s.diceCount === 1 ? "die" : "dice"}`}
                  </span>
                </span>
              ) : null}
              {actor ? <span className="seat-tag">Up now</span> : null}
            </li>
          );
        })}
      </ul>
      {showProgress && model.progress ? (
        <p className="table-progress" role="status">
          {model.progress.submitted} / {model.progress.eligible} submitted
        </p>
      ) : null}
    </div>
  );
}
